import { Pipe, PipeTransform } from '@angular/core';
import { PDQIQDeliveryPromise, RadioButtonsConfig, ShippingMethod } from '@pages/checkout-app/types';
import { Checkout, ICheckoutEstimatedTimeConversion } from '@pdqdev/pdq-shared/dist/interfaces';
import { DropdownOption } from '@storybook/components/dropdown/dropdown.component';
import FeePerWeekdayRule = Checkout.FeePerWeekdayRule;
import { isNumber } from 'lodash';
import { Carrier } from '@pdqdev/pdq-shared/dist/entities';
import { CarrierTypeNames } from '@pdqdev/pdq-shared/dist/CarrierData';

@Pipe({
  name: 'replaceUnderscore',
  standalone: false,
})
export class ReplaceUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(new RegExp('_', 'g'), ' ');
  }
}

@Pipe({
  name: 'dpInputTitle',
  standalone: false,
})
export class DeliveryPromiseInputTitlePipe implements PipeTransform {
  transform(shippingMethod: string, estimatedTimeConverstion: string): string {
    const displayTiming = {
      [ShippingMethod.DOMESTIC]: 'days',
      [ShippingMethod.LOCAL]: 'hours',
      [ShippingMethod.DOMESTIC_LIVE_RATE]: 'days',
      [ShippingMethod.INTERNATIONAL_FIXED]: 'days',
      [ShippingMethod.INTERNATIONAL_LIVE_RATE]: 'days',
      [ShippingMethod.FIXED_LIVE_RATE]: 'days',
      [ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE]: 'days',
      [ShippingMethod.STORE_PICK_UP]: 'days',
    };
    let title = 'delivery';
    if (
      ((shippingMethod === ShippingMethod.DOMESTIC_LIVE_RATE ||
        shippingMethod === ShippingMethod.FIXED_LIVE_RATE ||
        shippingMethod === ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE ||
        shippingMethod === ShippingMethod.INTERNATIONAL_LIVE_RATE) &&
        estimatedTimeConverstion === ICheckoutEstimatedTimeConversion.LIVE) ||
      estimatedTimeConverstion === ICheckoutEstimatedTimeConversion.PDQIQ
    ) {
      title = 'processing';
    }
    return title + ' ' + displayTiming[shippingMethod];
  }
}

@Pipe({
  name: 'decreaseWeekDayOption',
  standalone: false,
})
export class DecreaseWeekDayOption implements PipeTransform {
  transform(options: DropdownOption[], rules: FeePerWeekdayRule[]) {
    if (!rules?.length) {
      return undefined;
    }
    const chosenDays = rules.map((r) => isNumber(r.weekday) && r.weekday.toString());
    return options.filter((o) => +o.value > 8 || !chosenDays.includes(o.value.toString()));
  }
}

@Pipe({
  name: 'pdqiqZoneDeliveryPromiseDays',
  pure: true,
  standalone: false,
})
export class PDQIQZoneDeliveryPromiseDays implements PipeTransform {
  transform(zone: PDQIQDeliveryPromise, percentile: number): string {
    // Based on the given percentile, return the corresponding delivery days.
    switch (percentile) {
      case 25:
        return Math.ceil(zone.percentile25ClickToDoorBusinessDays).toString();
      case 50:
        return Math.ceil(zone.medianClickToDoorBusinessDays).toString();
      case 80:
        return Math.ceil(zone.percentile80ClickToDoorBusinessDays).toString();
      case 90:
        return Math.ceil(zone.percentile90ClickToDoorBusinessDays).toString();
      case 95:
        return Math.ceil(zone.percentile95ClickToDoorBusinessDays).toString();
      case 99:
        return Math.ceil(zone.percentile99ClickToDoorBusinessDays).toString();
      default:
        return '';
    }
  }
}

@Pipe({
  name: 'GEODeliveryAreaConfigFilter',
  standalone: false,
})
export class GEODeliveryAreaConfigFilter implements PipeTransform {
  transform(options: RadioButtonsConfig[], selectedCountry: string, method: ShippingMethod): RadioButtonsConfig[] {
    return options.filter((option) => option.display?.(selectedCountry, method));
  }
}

@Pipe({
  name: 'displayDDPAdditionalConfig',
  standalone: false,
})
export class DisplayDDPAdditionalConfig implements PipeTransform {
  transform(taxPaymentType: 'DDP' | 'DDU', carrier: Carrier | undefined): boolean {
    const carrierTypesSupportDDPTaxBreakDown = [CarrierTypeNames.FLAVOR_CLOUD, CarrierTypeNames.PASSPORT];
    return taxPaymentType === 'DDP' && carrierTypesSupportDDPTaxBreakDown.includes(carrier?.type?.name);
  }
}
